exports = module.exports = require("../../../../digicerba-factures/digicerba-factures-web/src/angular/cerba/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notification {\n  background-color: #4472C4;\n  font-family: \"Colaborate Light\", Helvetica, Verdana, \"DejaVu Sans\", Arial, sans;\n  font-size: 14px;\n  color: #FFFFFF;\n  text-align: center;\n  width: 100%;\n  padding: 2%;\n  margin-bottom: 2%;\n  line-height: 1.384615385; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/message-notification/message-notification-component.scss
// module id = ../../../../../../../../../../digicerba-common-module/src/components/message-notification/message-notification-component.scss
// module chunks = 1